'use strict';

var libphonenumberJs = require('libphonenumber-js');

var formatPhoneNumber = function (number, countryCode, extension) {
    var formattedNumber = libphonenumberJs.parsePhoneNumberFromString(number, countryCode);
    var phoneNumber = formattedNumber ? formattedNumber.formatNational() : number;
    phoneNumber = "" + phoneNumber + (extension ? " x" + extension : '');
    return phoneNumber;
};

module.exports = formatPhoneNumber;
